"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentIcon = void 0;
const react_1 = __importDefault(require("react"));
const ComponentIcon = ({ name = 'widgets', color = 'teal' }) => {
    // Determine if we need hex inline style
    const hex = /^#[0-9A-F]{6}$/i.test(color) ? { background: color } : {};
    return (react_1.default.createElement("span", { "aria-hidden": true, style: hex, className: `component-service__component-icon component-service__component-icon--color-${color}` }, name));
};
exports.ComponentIcon = ComponentIcon;
